// removed by extract-text-webpack-plugin
module.exports = {"link":"link__27HoT","question":"question__Dv6di","open":"open__3wj_q","answer":"answer__2moJn"};


//////////////////
// WEBPACK FOOTER
// ./styles/homePage/question.scss
// module id = 494
// module chunks = 68